export default "__VITE_ASSET__DDIVrMOA__$_?url__"